import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BASE_SITE_URL,
  BASE_SITE_PRIVACY_SECTION,
  CUSTOMER_SUPPORT_EMAIL,
} from 'src/utils/Urls';
import { Container, SupportLink, PublicFooterWraper } from './Footer.styles';

const FooterPublic: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <PublicFooterWraper>
        {/* Support link */}
        <SupportLink
          href={`mailto:${CUSTOMER_SUPPORT_EMAIL}`}
          target="_blank"
          rel="noreferrer"
        >
          {t('FOOTER_LINK_SUPPORT')}
        </SupportLink>

        {/* Privacy link */}
        <SupportLink
          href={BASE_SITE_PRIVACY_SECTION}
          target="_blank"
          rel="noreferrer"
        >
          {t('FOOTER_LINK_PRIVACY')}
        </SupportLink>

        {/* Company link */}
        <SupportLink href={BASE_SITE_URL} target="_blank" rel="noreferrer">
          {t('FOOTER_LINK_COMPANY')}
        </SupportLink>
      </PublicFooterWraper>
    </Container>
  );
};

export default FooterPublic;
